import { TeamMembersRequestStatus } from '__generated__/GQL';

import { RequestsFilterState } from './types';

export const RequestsFilterStateToStatus: Record<
  RequestsFilterState,
  TeamMembersRequestStatus[]
> = {
  [RequestsFilterState.Pending]: [TeamMembersRequestStatus.Pending],
  [RequestsFilterState.Processing]: [
    TeamMembersRequestStatus.Approved,
    TeamMembersRequestStatus.Processed,
  ],
  [RequestsFilterState.Done]: [
    TeamMembersRequestStatus.Canceled,
    TeamMembersRequestStatus.Completed,
    TeamMembersRequestStatus.Rejected,
  ],
};

export const TeamRequestStatusToRequestsFilterState: Record<
  TeamMembersRequestStatus,
  RequestsFilterState
> = {
  [TeamMembersRequestStatus.Pending]: RequestsFilterState.Pending,
  [TeamMembersRequestStatus.Approved]: RequestsFilterState.Processing,
  [TeamMembersRequestStatus.Canceled]: RequestsFilterState.Done,
  [TeamMembersRequestStatus.Completed]: RequestsFilterState.Done,
  [TeamMembersRequestStatus.Processed]: RequestsFilterState.Processing,
  [TeamMembersRequestStatus.Rejected]: RequestsFilterState.Done,
};
